import { createEnum } from "@redotech/zod-util/zod-enum";
import {
  CallDirection,
  CallState,
  RingingStrategy,
  UserCallAvailability,
  WebRTCCallState,
} from "./voice-types";

export const userCallAvailabilitySchema = createEnum([
  UserCallAvailability.AVAILABLE,
  UserCallAvailability.IN_CALL,
  UserCallAvailability.UNAVAILABLE,
]);

export const webRTCCallStateSchema = createEnum([
  WebRTCCallState.NEW,
  WebRTCCallState.TRYING,
  WebRTCCallState.REQUESTING,
  WebRTCCallState.RECOVERING,
  WebRTCCallState.RINGING,
  WebRTCCallState.ANSWERING,
  WebRTCCallState.EARLY,
  WebRTCCallState.ACTIVE,
  WebRTCCallState.HELD,
  WebRTCCallState.HANGUP,
  WebRTCCallState.DESTROY,
  WebRTCCallState.PURGE,
]);

export const callDirectionSchema = createEnum([
  CallDirection.INBOUND,
  CallDirection.OUTBOUND,
]);

export const callStateSchema = createEnum([
  CallState.RINGING,
  CallState.ACTIVE,
  CallState.CONNECTING,
  CallState.HANGUP,
]);

export const ringingStrategySchema = createEnum([
  RingingStrategy.ROUND_ROBIN,
  RingingStrategy.RING_TEAM,
]);
